// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiDiagnosisCodeResult {
    static getAttributeTypeMap() {
        return MedicalBiDiagnosisCodeResult.attributeTypeMap;
    }
}
MedicalBiDiagnosisCodeResult.discriminator = undefined;
MedicalBiDiagnosisCodeResult.additionalProperties = false;
MedicalBiDiagnosisCodeResult.attributeTypeMap = [
    {
        "name": "coInsurance",
        "baseName": "coInsurance",
        "type": "string"
    },
    {
        "name": "copay",
        "baseName": "copay",
        "type": "string"
    },
    {
        "name": "deductibleApplies",
        "baseName": "deductibleApplies",
        "type": "boolean"
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": "string"
    },
    {
        "name": "code",
        "baseName": "code",
        "type": "string"
    },
    {
        "name": "unit",
        "baseName": "unit",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiDiagnosisCodeResult.js.map